module.exports = __webpack_public_path__ + "static/media/ic-doc_newdoc.9fee6cac.png";